import React from "react";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./MainLayout";

import ErrorLayout from "./ErrorLayout";

import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";

import Login from "components/Login/Login";

import Exercises from "components/Exercises/Exercises";
import Recipes from "components/Recipes/Recipes";
import PageTitlesEditor from "components/PageTitles/PageTitles";
import VirtualCommute from "components/VirtualCommute/VirtualCommute";
import Mindfulness from "components/Mindfulness/Mindfulness";
import Dashboard from "components/dashboard";
import Users from "components/Users/Users";
import Businesses from "components/Businesses/Businesses";
import AppReports from "components/AppReports/AppReports";

const Layout = () => {
  return (
    <>
      <Routes>
        <Route element={<ErrorLayout />}>
          <Route path="errors/404" element={<Error404 />} />
          <Route path="errors/500" element={<Error500 />} />
        </Route>

        <Route path="login" element={<Login />} />
        <Route path="/" element={<Login />} />

        <Route element={<MainLayout />}>
          {/*Dashboard*/}
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/recipes" element={<Recipes />} />
          <Route path="/admin/exercise-routines" element={<Exercises />} />
          <Route path="/admin/mindfulness" element={<Mindfulness />} />
          <Route path="/admin/virtual-commute" element={<VirtualCommute />} />
          <Route path="/admin/page-titles" element={<PageTitlesEditor />} />
          <Route path="/admin/users" element={<Users />} />
          <Route path="/admin/businesses" element={<Businesses />} />
          <Route path="/admin/app-reports" element={<AppReports />} />
        </Route>
      </Routes>
    </>
  );
};

export default Layout;
